// @ts-check
import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import styles from './ActionMenu.module.css';

/**
 * @component ActionMenu
 * @author Hrithvik Gadhiya
 * @date July 20, 2023
 * @param { Object } props
 * @param { boolean } props.open
 * @param { function } props.handleClose
 * @param { Object } props.anchorEl
 * @param { Object } props.actions
 * @returns { JSX.Element }
 */

export default function ActionMenu({ open, handleClose, anchorEl, actions }) {
	return (
		<>
			<Menu
				open={open}
				onClose={handleClose}
				anchorEl={anchorEl}
				anchorReference="anchorPosition"
				anchorPosition={
					anchorEl
						? { top: anchorEl.top, left: anchorEl.left }
						: undefined
				}
				onContextMenu={(e) => {
					e.preventDefault();
					e.stopPropagation();
					handleClose();
				}}
				className={styles.menu}
			>
				{/* <Divider /> */}
				{actions.map((action, index) => {
					return (
						<MenuItem
							onClick={(e) => {
								e.stopPropagation();
								action.handler();
								handleClose();
							}}
							onTouchStart={(e) => {
								e.stopPropagation();
								e.preventDefault();
							}}
							onTouchEnd={(e) => {
								e.stopPropagation();
								e.preventDefault();
								action.handler();
								handleClose();
							}}
							className={styles.menu_item}
							key={index}
							disabled={action.disabled || false}
						>
							<ListItemIcon className={styles.list_icon}>
								{action.icon}
							</ListItemIcon>
							<ListItemText>{action.text}</ListItemText>
						</MenuItem>
					);
				})}
			</Menu>
		</>
	);
}
